module.exports = __webpack_public_path__ + "img/kosovo.2937ddb0.svg";